<template>
  <div>
    <EbHeading v-if="!idEnfant && (!isMobile && !isSmallScreen)" level="h1" class="eb-page-heading">Nouvel accueil</EbHeading>
    <router-link v-if="idEnfant && (!isMobile && !isSmallScreen)" :to="{name: 'mesAccueils'}" class="back-link" title="Retour à mes accueils"><font-awesome-icon :icon="['fas', 'arrow-left']" size="2x" /><span class="sr-only">Retour à mes accueils</span></router-link>
    <EbHeading v-if="idEnfant && (!isMobile && !isSmallScreen)" level="h1" class="eb-page-heading">Modifier la fiche de {{ enfant.nom }} {{ enfant.prenom }}</EbHeading>
    <div class="eb-content-default w75">
      
      <EbBanner :isActive="errorOnSave" :timestamp="bannerTimestamp" type="error">Une erreur est survenue, veuillez vérifier votre saisie.</EbBanner>
      
      <EbMultisteps v-if="!idEnfant" :items="[{name: 'Enfant accueilli'}, {name: 'Informations sur les parents'}, {name: 'Modalités d’accueil'}, {name: 'Récapitulatif'}]" :isActive="page"></EbMultisteps>
      <EbMultisteps v-else :items="[{name: 'Informations sur les parents'}, {name: 'Modalités d’accueil'}, {name: 'Récapitulatif'}]" :isActive="page-1"></EbMultisteps>
      
      <form action="#" @submit.prevent="doAction" ref="focusTarget">
        
        <div v-if="!idEnfant && page == 0">
          <EbHeading level="h2" class="eb-box-heading">Enfant accueilli</EbHeading>
          <EbBanner :isActive="errorDates" type="error" :timestamp="bannerTimestamp">Veuillez vérifier la date d’arrivée, elle ne peut être antérieur à la date de naissance de l’enfant accueilli.</EbBanner>
          
          <EbInput label="Nom de l’enfant" v-model="enfant.nom" required></EbInput>
          <EbInput label="Prénom de l’enfant" v-model="enfant.prenom" required></EbInput>
          
          <EbInput label="Date de naissance de l’enfant (jj/mm/aaaa)" type="date" :max="maxDate" required v-model="enfant.dateNaissance"></EbInput>
          
          <EbInput label="Date d’arrivée de l’enfant (jj/mm/aaaa)" type="date" required v-model="enfant.dateArrivee"></EbInput>
          
          <div class="eb-button-group-prev-next">
            <EbButton type="submit" withIcon="icon-after" hierarchy="secondary"> Étape suivante <font-awesome-icon :icon="['fas', 'chevron-right']" class="icon" /> </EbButton>
          </div>
          <div class="eb-button-group">
            <EbLinkButton :to="{name: 'mesAccueils'}" class="medium text">Annuler la saisie</EbLinkButton>
          </div>
        </div>
        
        <div v-if="page == 1">
          <EbHeading level="h2" class="eb-box-heading">Informations sur les parents</EbHeading>
          
          <fieldset>
            <legend>Coordonnées du premier parent</legend>            
            <EbInput label="Nom et prénom du parent" v-model="enfant.parentsEnfant[0].nom" required></EbInput>
            <EbTextarea label="Adresse du parent" v-model="enfant.parentsEnfant[0].adresse" required></EbTextarea>
            <EbInput type="tel" label="Téléphone du parent" v-model="enfant.parentsEnfant[0].telephone" required></EbInput>
          </fieldset>
          
          <EbDisclosure v-model="hasParent2" label="Déclarer des coordonnées différentes pour le deuxième parent" isSwitch @input='switchSecondParent' groupTag="fieldset" legend="Coordonnées du deuxième parent">
            <EbInput label="Nom et prénom du parent" v-model="enfant.parentsEnfant[1].nom" :required="hasParent2?true:null"></EbInput>
            
            <EbTextarea label="Adresse du parent" v-model="enfant.parentsEnfant[1].adresse" :required="hasParent2?true:null"></EbTextarea>
            
            <EbInput type="tel" label="Téléphone du parent" v-model="enfant.parentsEnfant[1].telephone" :required="hasParent2?true:null"></EbInput>
          </EbDisclosure>
          
          <div class="eb-button-group-prev-next">
            <EbButton v-if="!idEnfant" @click.prevent="changePageDown()" withIcon="icon-before" hierarchy="secondary">
              <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon" />Étape précédente
            </EbButton>
            <EbButton type="submit" withIcon="icon-after" hierarchy="secondary">
              Étape suivante <font-awesome-icon :icon="['fas', 'chevron-right']" class="icon" />
            </EbButton>
          </div>
        </div>
        
        <div v-if="page == 2" id="checkboxModalites">
          <EbHeading level="h2" class="eb-box-heading">Modalités d’accueil</EbHeading>
          <EbBanner :isActive="errorModalites" type="error" :timestamp="bannerTimestamp">Veuillez cocher au moins une modalité d’accueil</EbBanner>
          
          <fieldset>
            <legend>Vous accueillez l'enfant :</legend>
            <EbCheckbox label="Toute la journée" labelRight v-model="enfant.modaliteAccueilEnfant.accueilJournee"></EbCheckbox>
            <EbCheckbox label="Matin" labelRight v-model="enfant.modaliteAccueilEnfant.accueilMatin"></EbCheckbox>
            <EbCheckbox label="Après-midi" labelRight v-model="enfant.modaliteAccueilEnfant.accueilApresMidi"></EbCheckbox>
            <EbCheckbox label="Midi" labelRight v-model="enfant.modaliteAccueilEnfant.accueilMidi"></EbCheckbox>
            <EbCheckbox label="Mercredi" labelRight v-model="enfant.modaliteAccueilEnfant.accueilMercredi"></EbCheckbox>
            <EbCheckbox label="Matin avant l’école" labelRight v-model="enfant.modaliteAccueilEnfant.accueilMatinAvantEcole"></EbCheckbox>
            <EbCheckbox label="Soir après l’école" labelRight v-model="enfant.modaliteAccueilEnfant.accueilSoirApresEcole"></EbCheckbox>
            <EbCheckbox label="Vacances scolaires" labelRight v-model="enfant.modaliteAccueilEnfant.accueilVacancesScolaires"></EbCheckbox>
          </fieldset>
          
          <EbTextarea label="Autre modalité d'accueil, préciser" :rows="8" width="expand" v-model="enfant.modaliteAccueilEnfant.accueilAutre"></EbTextarea>
          
          <EbTextarea label="Commentaire sur les modalités d'accueil" :rows="8" width="expand" v-model="enfant.modaliteAccueilEnfant.commentaire"></EbTextarea>
          
          <div class="eb-button-group-prev-next">
            <EbButton @click.prevent="changePageDown()" withIcon="icon-before" hierarchy="secondary"><font-awesome-icon :icon="['fas', 'chevron-left']" class="icon" /> Étape précédente</EbButton>
          </div>
          <div class="eb-button-group">
            <EbButton type="submit">Aller au récapitulatif</EbButton>
          </div>
        </div>
        
        <div v-if="page == 3">
          <EbHeading level="h2" class="eb-box-heading">Enfant accueilli</EbHeading>
          <div class="flex">
            <font-awesome-icon :icon="['fas', 'baby']" size="3x" class="mr-20" />
            <p>
              <strong>
                <span class="text-uppercase">{{ enfant.nom }}</span> {{ enfant.prenom }}
              </strong>
              <br />
              Né(e) le <time :datetime="enfant.dateNaissance">{{ getLongDate(enfant.dateNaissance) }}</time>
            </p>
          </div>
          
          <EbHeading level="h2" class="eb-box-heading">Informations sur les parents</EbHeading>
          <div class="flex">
            <div v-for="pe in enfant.parentsEnfant" class="flex mr-36">
              <font-awesome-icon v-if="pe.nom" :icon="['fas', 'user-friends']" size="2x" class="mr-20" />
              <p>
                <strong>{{ pe.nom }}</strong>
                <br />
                <span v-if="pe.adresse">{{ pe.adresse }}</span>
                <br />
                {{ pe.telephone }}
              </p>
            </div>
          </div>
          
          <EbHeading level="h2" class="eb-box-heading">Modalités d’accueil</EbHeading>
          <ul class="eb-list-check">
            <li v-if="enfant.modaliteAccueilEnfant.accueilJournee"><font-awesome-icon :icon="['fas', 'check']" />Journée</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilMatin"><font-awesome-icon :icon="['fas', 'check']" />Matin</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilApresMidi"><font-awesome-icon :icon="['fas', 'check']" />Après-midi</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilMidi"><font-awesome-icon :icon="['fas', 'check']" />Midi</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilMercredi"><font-awesome-icon :icon="['fas', 'check']" />Mercredi</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilMatinAvantEcole"><font-awesome-icon :icon="['fas', 'check']" />Matin, avant l’école</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilSoirApresEcole"><font-awesome-icon :icon="['fas', 'check']" />Soir, après l’école</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilVacancesScolaires"><font-awesome-icon :icon="['fas', 'check']" />Vacances scolaires</li>
            <li v-if="enfant.modaliteAccueilEnfant.accueilAutre"><font-awesome-icon :icon="['fas', 'check']" />Autres modalités : {{ enfant.modaliteAccueilEnfant.accueilAutre }}</li>
          </ul>
          <p v-if="enfant.modaliteAccueilEnfant.commentaire">
            Commentaire : <br /><b>{{ enfant.modaliteAccueilEnfant.commentaire }}</b>
          </p>
          <p>
            Date d’arrivée de l’enfant : <br /><b><time :datetime="enfant.dateArrivee">{{ getLongDate(enfant.dateArrivee) }}</time></b>
          </p>
          
          <div class="eb-button-group">
            <EbButton @click.prevent="changePageDown()" withIcon="icon-before" hierarchy="secondary">Modifier des informations</EbButton>
            <EbButton type="submit">Envoyer la déclaration</EbButton>
          </div>
        </div>
      </form>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'accueilEnfant',
  props: {
    idEnfant: null,
  },
  data() {
    return {
      page: 0,
      errorModalites: false,
      hasParent2: false,
      hasModalitesAutres: false,
      enfant: {
        modaliteAccueilEnfant: {},
        parentsEnfant: [{}, {}],
      },
      errorOnSave: false,
      errorDates: false,
      bannerTimestamp: null
    }
  },
  mounted() {
    if (this.idEnfant) {
      this.getEnfant()
    }
  },
  computed: {
    maxDate: function() {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate())
      return tomorrow.toISOString().slice(0, 10)
    },
  },
  methods: {
    getEnfant: async function() {
      await this.$http.get('assmat/enfants/' + this.idEnfant).then(resp => {
        this.enfant = resp.data
        this.page = 1
        
        let p2 = this.enfant.parentsEnfant[1]
        if(p2.nom && p2.adresse && p2.telephone) {
          this.hasParent2 = true
        }
        else {
          this.enfant.parentsEnfant.push({
            adresse: '',
            nom: '',
            telephone: '',
          })
        }
      })
    },
    createEnfant: async function() {
      await this.$http
      .post('assmat/enfants/nouvelAccueil', {
        nom: this.enfant.nom,
        prenom: this.enfant.prenom,
        dateNaissance: this.enfant.dateNaissance,
        dateArrivee: this.enfant.dateArrivee,
        modaliteAccueilEnfant: {
          accueilApresMidi: this.enfant.modaliteAccueilEnfant.accueilApresMidi,
          accueilAutre: this.enfant.modaliteAccueilEnfant.accueilAutre,
          accueilJournee: this.enfant.modaliteAccueilEnfant.accueilJournee,
          accueilMatin: this.enfant.modaliteAccueilEnfant.accueilMatin,
          accueilMatinAvantEcole: this.enfant.modaliteAccueilEnfant.accueilMatinAvantEcole,
          accueilMercredi: this.enfant.modaliteAccueilEnfant.accueilMercredi,
          accueilMidi: this.enfant.modaliteAccueilEnfant.accueilMidi,
          accueilSoirApresEcole: this.enfant.modaliteAccueilEnfant.accueilSoirApresEcole,
          accueilVacancesScolaires: this.enfant.modaliteAccueilEnfant.accueilVacancesScolaires,
          commentaire: this.enfant.modaliteAccueilEnfant.commentaire
        },
        parentsEnfant: [
          {
            adresse: this.enfant.parentsEnfant[0].adresse,
            nom: this.enfant.parentsEnfant[0].nom,
            telephone: this.enfant.parentsEnfant[0].telephone,
            ordre: 0,
          },
          {
            adresse: this.enfant.parentsEnfant[1].adresse,
            nom: this.enfant.parentsEnfant[1].nom,
            telephone: this.enfant.parentsEnfant[1].telephone,
            ordre: 1,
          },
        ],
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status: 'create'}})
      })
      .catch(error => {
        this.errorOnSave = true
        this.bannerTimestamp = this.getTime()
      })
    },
    updateEnfant: async function() {
      await this.$http
      .put(`assmat/enfants/${this.idEnfant}/modifAccueil`, {
        nom: this.enfant.nom,
        prenom: this.enfant.prenom,
        dateNaissance: this.enfant.dateNaissance,
        dateArrivee: this.enfant.dateArrivee,
        modaliteAccueilEnfant: {
          accueilApresMidi: this.enfant.modaliteAccueilEnfant.accueilApresMidi,
          accueilAutre: this.enfant.modaliteAccueilEnfant.accueilAutre,
          accueilJournee: this.enfant.modaliteAccueilEnfant.accueilJournee,
          accueilMatin: this.enfant.modaliteAccueilEnfant.accueilMatin,
          accueilMatinAvantEcole: this.enfant.modaliteAccueilEnfant.accueilMatinAvantEcole,
          accueilMercredi: this.enfant.modaliteAccueilEnfant.accueilMercredi,
          accueilMidi: this.enfant.modaliteAccueilEnfant.accueilMidi,
          accueilSoirApresEcole: this.enfant.modaliteAccueilEnfant.accueilSoirApresEcole,
          accueilVacancesScolaires: this.enfant.modaliteAccueilEnfant.accueilVacancesScolaires,
          commentaire: this.enfant.modaliteAccueilEnfant.commentaire,
        },
        parentsEnfant: [
          {
            adresse: this.enfant.parentsEnfant[0].adresse,
            nom: this.enfant.parentsEnfant[0].nom,
            telephone: this.enfant.parentsEnfant[0].telephone,
            ordre: 0,
          },
          {
            adresse: this.enfant.parentsEnfant[1].adresse,
            nom: this.enfant.parentsEnfant[1].nom,
            telephone: this.enfant.parentsEnfant[1].telephone,
            ordre: 1,
          },
        ],
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status:'update'}})
      })
      .catch(error => {
        this.errorOnSave = true
        this.bannerTimestamp = this.getTime()
      })
    },
    isModalitesValid: function() {
      let cbs = document.getElementById('checkboxModalites').querySelectorAll('input[type="checkbox"]:checked')
      if (cbs.length === 0) {
        this.errorModalites = true
        this.bannerTimestamp = this.getTime()
        return false
      } else {
        this.errorModalites = false
        return true
      }
    },
    isDatesCompatibles: function() {
      if(this.enfant.dateNaissance > this.enfant.dateArrivee) {
        this.errorDates = true
        this.bannerTimestamp = this.getTime()
        return false
      }
      else {
        this.errorDates = false
        return true
      }
    },
    submitDatas: function() {
      if (!this.idEnfant) this.createEnfant()
      else this.updateEnfant()
    },
    doAction: function() {
      if(this.page === 2) {
        if(!this.isModalitesValid()) return false
      }
      else if(this.page === 0) {
        if(!this.isDatesCompatibles()) return false
      }
      else if(this.page === 3) this.submitDatas()
      
      this.changePageUp()
    },
    switchSecondParent: function() {
      if(!this.hasParent2) {
        this.enfant.parentsEnfant[1] = {}
      }
    }
  }
}
</script>
